/* CUSTOM deg-endmark — DEG-Schluss-Marke (Schriftzeichen U+E001, seit 15.09.2026, vorher U+E000)
   nur EINMAL pro Seite:
   nach dem letzten Editorial-Absatz. Taggt den letzten passenden <p> mit .deg-endmark
   (CSS zeigt die Marke nur dort).
   Opt-in via .deg-editorial: NUR echte Longform-Editorials (About-Spread, coffee-why,
   Editorial-Page, Home-Story) — NICHT funktionale Texte wie studio-intro (Adresse/Zeiten),
   die zwar .editorial fuer die Typo tragen, aber keine Schluss-Marke bekommen sollen. */
(function () {
  /* Ein Block MIT Button ist ein Navigations-Block (Two channels), kein Schluss des Lesetexts:
     die Marke saesse sonst unter einem CTA statt hinter dem letzten Absatz des Essays.
     (Folke 2026-07-16.) */
  var SEL = '.deg-editorial > p:last-of-type, .home-editorial-intro__text:not(:has(.home-editorial-intro__cta)) .home-editorial-intro__body > p:last-of-type';
  function markEnd() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('deg-endmark');
    if (nodes.length) nodes[nodes.length - 1].classList.add('deg-endmark');
  }
  if (document.readyState !== 'loading') markEnd();
  else document.addEventListener('DOMContentLoaded', markEnd);
})();
